import * as TypeStyle from 'typestyle';

export enum AlertType {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export const ColorMap: { [key in AlertType]: {
  accentColor: React.CSSProperties['borderColor'],
  borderColor: React.CSSProperties['borderColor'],
  backgroundColor: React.CSSProperties['backgroundColor'],
  hoverColor: React.CSSProperties['backgroundColor'],
} } = {
  success: {
    accentColor: '#91db8b',
    borderColor: '#22683e',
    backgroundColor: '#cdefc4',
    hoverColor: '#91db8b',
  },
  info: {
    accentColor: '#90d0fe',
    borderColor: '#05628a',
    backgroundColor: '#cfe9fe',
    hoverColor: '#90d0fe',
  },
  warning: {
    accentColor: '#fcc003',
    borderColor: '#6f3400',
    backgroundColor: '#f9e3b6',
    hoverColor: '#fcc003',
  },
  error: {
    accentColor: '#feb8ab',
    borderColor: '#ba0517',
    backgroundColor: '#feded8',
    hoverColor: '#feb8ab',
  },
};

export const AlertBaseColorStyleName: string = TypeStyle.style({
  $nest: {
    [`&.${AlertType.Success}`]: {
      backgroundColor: ColorMap.success.backgroundColor,
      borderColor: ColorMap.success.borderColor,
    },
    [`&.${AlertType.Info}`]: {
      backgroundColor: ColorMap.info.backgroundColor,
      borderColor: ColorMap.info.borderColor,
    },
    [`&.${AlertType.Warning}`]: {
      backgroundColor: ColorMap.warning.backgroundColor,
      borderColor: ColorMap.warning.borderColor,
    },
    [`&.${AlertType.Error}`]: {
      backgroundColor: ColorMap.error.backgroundColor,
      borderColor: ColorMap.error.borderColor,
    },
  }
});
